/**
 * Bump this value whenever the virtual try-on consent language or either
 * linked policy changes materially. The server accepts only this version and
 * records it with the generation attempt.
 */
export const VIRTUAL_TRY_ON_CONSENT_VERSION = "2026-08-21.v1";

export const VIRTUAL_TRY_ON_TERMS_PATH = "/service-agreement";
export const VIRTUAL_TRY_ON_PRIVACY_PATH = "/privacy-policy";
